import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { VideoOutgoingTemplate } from "~/features/call/video/VideoOutgoingTemplate";
import { useCallStore } from "~/stores/useCallStore";

// `?mic_off=true` 形式のフラグ。真値以外・未指定はすべて false に倒す
// （z.coerce.boolean() は文字列 "false" も true になるため使わない）
const flagParam = z
  .unknown()
  .optional()
  .transform((v) => v === true || v === "true");

const outgoingSearchSchema = z.object({
  partner_id: z.string().optional(),
  partner_name: z.string().catch(""),
  partner_avatar: z.string().optional(),
  partner_age: z.coerce.number().optional(),
  /** 発信前モーダルでマイク OFF を選んだか */
  mic_off: flagParam,
  /** 発信前モーダルでカメラ OFF を選んだか */
  camera_off: flagParam,
});

const VideoOutgoingPage = () => {
  const search = Route.useSearch();
  // partner_id は beforeLoad で必須チェック済み
  return (
    <VideoOutgoingTemplate
      partnerId={search.partner_id ?? ""}
      partnerName={search.partner_name}
      partnerAvatarUrl={search.partner_avatar}
      partnerAge={search.partner_age}
      deviceOptions={{ micOff: search.mic_off, cameraOff: search.camera_off }}
    />
  );
};

export const Route = createFileRoute("/_authenticated/call/video/outgoing")({
  validateSearch: outgoingSearchSchema,
  staticData: { hideBottomNav: true },
  beforeLoad: ({ search }) => {
    if (!search.partner_id) {
      throw redirect({ to: "/discover" });
    }
    const { phase } = useCallStore.getState();
    if (phase.type !== "idle" && phase.type !== "outgoingConnecting") {
      throw redirect({ to: "/discover" });
    }
  },
  component: VideoOutgoingPage,
});
